import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from 'app/shared/restApiServices/restapi.service';
import { RenderZingChartService } from 'app/shared/services/render.zingchart.service';
import * as L from 'leaflet';
import 'leaflet.markercluster';

declare var zingchart: any;
@Component({
  selector: 'app-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.css']
})
export class PreviewDialogComponent implements OnInit {

  selectedTab: "graph"|"table"|"map" = "graph";
  surveyorList: {sno:number,surveyor:string,mobileNo:string,responses:number}[]=[];
  displayedColumns: string[] = [ 'surveyor', 'responses'];
  surveyor;
  surveyId;
  responseList;
  mainResponseList;
  selectedResponse;
  previewType:'response'|'surveyor'='response';

  // map....

  map: L.Map;
  markers: L.Marker[] = [];
  options1 = {
    layers: [
      L.tileLayer('http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        attribution: 'map'
      })
    ],
    zoom: 16,
    center: { lat: 28.626137, lng: 79.821603 }
  };
  initialMarkers: {position: { lat: number, lng: number },
  draggable: false,
  id:string}[] = [];
  unselected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-unselected.svg',
  });
  selected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-selected.svg',
  });
  markerClusterData: any[] = [];
  markerClusterGroup: L.MarkerClusterGroup;
  center=[20.5937, 78.9629];
  zoom = 4;
  // map...


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private restApiService: RestApiService,
  private graphService:RenderZingChartService,private dialog:MatDialog) { 
    this.surveyor = data.surveyor;
    this.surveyorList = data.surveyorList;
    this.surveyId = data.surveyId;
    this.previewType = data.dialogType;
    this.mainResponseList = data.responseList;
    this.selectedResponse = data.selectedResponse;
    this.getMapViewForSurvey();
    this.getDateUserWiseSurveyCount();
    if(this.previewType == 'response'){
      this.selectedTab = 'table';
    }
    else{
      this.selectedTab = 'graph';
    }
  }

  ngOnInit() {
  }

  onMapReady($event: L.Map) {
    this.map = $event;
    this.initMarkers();
  }
  
  initMarkers() {
    for (let index = 0; index < this.initialMarkers.length; index++) {
      const data = this.initialMarkers[index];
      const marker = this.generateMarker(data, index);
      marker.addTo(this.map).setIcon(this.unselected);
      this.map.panTo(data.position);
      this.markers.push(marker)
    }
  }
  generateMarker(data: any, index: number) {
    return L.marker(data.position, { draggable: data.draggable })
      .on('click', (event) => this.markerClicked(event, index))
      .on('dragend', (event) => this.markerDragEnd(event, index));
  }

  markerClicked($event: any, index: number) {
    const id= this.initialMarkers[index].id
    const position= this.initialMarkers[index].position;
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = $event;
  }

  markerDragEnd($event: any, index: number) {
    console.log($event.target.getLatLng());
  } 

  markerClusterReady(group: L.MarkerClusterGroup) {
    this.markerClusterGroup = group;
    let lat1, lng1;
    this.markerClusterGroup.options.iconCreateFunction = function (cluster) {
      return L.divIcon({ html: '<b style="padding:4px; background-color: #FFA17A; text-align: center;font-size: 12px; border-radius:50%; color:#FFFFFF"; font-weight: 500;font-family: "Roboto";font-style: normal;line-height: 14px;">' + cluster.getChildCount() + '</b>', className: 'my-div-icon', iconSize: L.point(40, 40),
      iconAnchor: L.point(7, 12) });
    }
    this.markerClusterGroup.options.maxClusterRadius = 10;
    this.markerClusterGroup.options.singleMarkerMode = true;
  }
  mapClicked($event: any) {
    console.log($event.latlng.lat, $event.latlng.lng);
  }

  getDateUserWiseSurveyCount(){
    const adminId = localStorage.getItem("selectedAdminIdForPerformance");
    let surveyorFilter;
    let date;
    let type;
    if(this.previewType == 'response'){
      // here we need to add date filter as start and end date..
      date = this.selectedResponse.property.length>=10?
              this.selectedResponse.property.substring(0,10):null;
      type = "surveyor";
    }
    else{
      // here we need to add surveyor as filter.
      surveyorFilter = this.surveyor.mobileNo;
      type = "date";
    }
    this.restApiService.getDateUserWiseSurveyCount(adminId,this.surveyId,type,
      null,date,date, surveyorFilter).subscribe(response=>{
        if(this.previewType == 'response'){
          this.getSurveyorList(response);
        }
        else{
          this.createResponseGraph(response);
        }
      })

  }

  mapValues:{name:string,date:string}[]=[];
  getMapViewForSurvey(){
    const adminId = localStorage.getItem("selectedAdminIdForPerformance");
    let surveyorFilter;
    let date;
    if(this.previewType == 'response'){
      // here we need to add date filter as start and end date..
      date = this.selectedResponse.property.substring(0,10);
    }
    else{
      // here we need to add surveyor as filter.
      surveyorFilter = this.surveyor.mobileNo;
    }
    this.restApiService.getMapViewForSurvey(adminId,this.surveyId,
      null,date,date,surveyorFilter).subscribe(response=>{
        if(response && response.length>0){
          response.forEach(data=>{
            const date = data.survey_date?data.survey_date.substring(0,10):'';
            this.mapValues.push({name:data.Name,date:date});
          })
          this.generateMap(response);
        }
      })

  }

  generateMap(response){
    this.markerClusterData = [];
    this.initialMarkers = [];
    this.zoom = 4;
    this.center = [20.5937, 78.9629];
    let count = 1;
    for (let i in response) {
      this.initialMarkers.push({position: {lat: response[i].lat, lng: response[i].lng},
        draggable:false, id: count.toString()});
      this.markerClusterData.push(L.marker([response[i].lat,response[i].lng],
        {'id': count.toString()}).setIcon(this.unselected).on('click', this.onclick.bind(this)));
      count = count +1;
    }
  }


  prevclick: any;
  onClickItem = false;
  surveyorName:string;
  surveyorDate:string;
  onclick = (e) => {
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = e;
    e.target.setIcon(this.selected);
    this.onClickItem = true;
    e.target.setIcon(this.selected);
    const index = +e.target.options.id - 1;
    this.surveyorName = this.mapValues[index].name;
    this.surveyorDate = this.mapValues[index].date;
  };

  onClickPrevious(){
    this.onClickItem = false;
    if(this.previewType == 'response'){
      const id = this.selectedResponse.sno;
      if(id ==1){
        return;
      }
      for (let index = 0; index < this.mainResponseList.length; index++) {
        if(this.mainResponseList[index].sno == id-1){
          this.selectedResponse = this.mainResponseList[index];
          this.getMapViewForSurvey();
          this.getDateUserWiseSurveyCount();
          break;
        }
      }
    }
    else{
      const id = this.surveyor.sno;
      if(id ==1){
        return;
      }
      for (let index = 0; index < this.surveyorList.length; index++) {
        if(this.surveyorList[index].sno == id-1){
          this.surveyor = this.surveyorList[index];
          this.getMapViewForSurvey();
          this.getDateUserWiseSurveyCount();
          break;
        }
      }
    }
  }

  onClickNext(){
    this.onClickItem = false;
    if(this.previewType == 'response'){
      const id = this.selectedResponse.sno;
      if(id == this.mainResponseList.length){
        return;
      }
      for (let index = 0; index < this.mainResponseList.length; index++) {
        if(this.mainResponseList[index].sno == id+1){
          this.selectedResponse = this.mainResponseList[index];
          this.getMapViewForSurvey();
          this.getDateUserWiseSurveyCount();
          break;
        }
      }
    }
    else{
      const id = this.surveyor.sno;
      if(id == this.surveyorList.length){
        return;
      }
      for (let index = 0; index < this.surveyorList.length; index++) {
        if(this.surveyorList[index].sno == id+1){
          this.surveyor = this.surveyorList[index];
          this.getMapViewForSurvey();
          this.getDateUserWiseSurveyCount();
          break;
        }
      }
    }
  }



  chartId = 'myCustomGraph2';
  createResponseGraph(response){
    let yData = [];
    let xData = [];
    if(response && response.length>0){
      response.forEach(data=>{
        yData.push(data.count);
        xData.push(data.property?data.property.substring(0,10):'');
      })
    }
    // transforming y data from string to number
    for (let index = 0; index < yData.length; index++) {
      yData[index] = Number(yData[index]);
    }
    const graphData = [{ values: yData,
      'background-color':'#009688'}];
    this.responseList = graphData;
    this.graphService.barChart2(graphData,xData,this.chartId);
    zingchart.bind(this.chartId, 'contextmenu', function(p) { return false;});
    // let chartConfig = {
    //   type: 'bar',
    //   series: [{
    //       values: [20, 40, 25, 50, 15, 45, 33, 34]
    //     }
    //   ],
    //   'scale-x': {
    //     labels: [ "Jan", "Feb", "March", "April", "May", "June", "July", "Aug" ] 
    //   }
    // };
     
    // zingchart.render({
    //   id: this.chartId,
    //   data: chartConfig, 
    //   height: '100%', 
    //   width: '100%' 
    // });
  }

  getSurveyorList(response){
    this.surveyorList = [];
    let index = 1;
    if(response && response.length>0){
      response.forEach(data=>{
        this.surveyorList.push({sno:index,surveyor:data.Name,mobileNo:data.property,responses:data.count});
        index = index+1;
      })
    }
  }


  setTab1(){
    this.onClickItem = false;
    if(this.previewType == 'response'){
      this.selectedTab = 'table';
    }
    else{
      this.selectedTab = 'graph';
    }
  }

  closeDialog(){
    this.dialog.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/preview-dialog/preview-dialog.component.ts